var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.detail)?_c('div',{staticStyle:{"padding":"15px","background":"white"},domProps:{"innerHTML":_vm._s(_vm.detail)}}):_c('div',{staticClass:"no-data"},[_vm._v("暂无相关信息")])}
var staticRenderFns = []

export { render, staticRenderFns }